import Colors from "../../constants/Colors";

export default {
	wrapperSize: 25,
	elementSize: 19,

	idling: {
		amplitude: 0,
		frameRate: 0,
		speed: 0,
		color: "rgba(0, 0, 0, 0.2)",
	},

	error: {
		amplitude: 4,
		frameRate: 30,
		speed: 0.15,
		color: Colors.red,
	},

	running: {
		amplitude: 8,
		frameRate: 30,
		speed: 0.25,
		color: Colors.green,
	},
};
